import { useFormik } from 'formik';
import React from 'react';
import { Input } from '../../Components/UI/Input';
import { emailSchema } from '../../Schema';
import AlertModal from '../AlertModal';
import classes from './ChangedNumber.module.css';
import ModalAction from '../ModalAction';
import Phone from '../../Components/UI/Phone';
import { changeNumberSchema } from '../../Schema';
const initialValues = {
  cellNumber: '',
  pinCode: ''
};
const ChangedNumberModal = ({ onSubmit, setShow, data, show, loading }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: changeNumberSchema,
    onSubmit: (values, { resetForm }) => {
      const params = {
        ...values
      };
      onSubmit(params, () => {
        setShow();
        resetForm();
      });
    }
  });
  const { touched, errors, values, handleSubmit, resetForm, setFieldValue, setFieldTouched } =
    formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const onCancel = () => {
    setShow(false);
    resetForm();
  };
  return (
    <AlertModal title={'Changed Number'} show={show} setShow={setShow} actions={false}>
      <form onSubmit={handleSubmit}>
        <Phone
          placeholder={'+92 XXX XXXXXXX'}
          errorText={touched?.cellNumber && errors?.cellNumber}
          value={values?.cellNumber}
          setter={(e) => {
            handleChangeWithTouch('cellNumber', e);
          }}
          id="cell-number-changed"
        />
        <Input
          className={classes['mt-8px']}
          placeholder="PinCode"
          value={values?.pinCode}
          setter={(e) => {
            handleChangeWithTouch('pinCode', e);
          }}
        />
        <ModalAction
          type="submit"
          isApiCall={loading}
          className={classes.actions}
          onCancel={() => {
            if (typeof onCancel === 'function') onCancel();
          }}
        />
      </form>
    </AlertModal>
  );
};

export default ChangedNumberModal;
